export const DOCUMENT_ACCESS_LEVEL_FIELD_ROWS = [
  {
    isAdmin: true,
    labelKey: 'DocumentsFolder.AccessAdminLabelKey',
    nameKey: 'admins',
    qaName: 'accessLevelAdmins',
  },
  {
    isManager: true,
    labelKey: 'DocumentsFolder.AccessManagerLabelKey',
    nameKey: 'managers',
    qaName: 'accessLevelManagers',
  },
  {
    labelKey: 'DocumentsFolder.AccessLandlordsLabelKey',
    nameKey: 'landlords',
    qaName: 'accessLevelLandlords',
  },
  {
    labelKey: 'DocumentsFolder.AccessTenantsLabelKey',
    nameKey: 'tenants',
    qaName: 'accessLevelTenants',
  },
]
